import { apiFetch } from './client'
import type { DashboardStats, ActivityItem } from './types'

export const dashboardApi = {
  stats: (token: string) =>
    apiFetch<DashboardStats>('/dashboard/stats', token),

  activity: (token: string) =>
    apiFetch<ActivityItem[]>('/dashboard/activity', token),
}
